/**
 * 상품 시설 관련 API 훅
 * 상품의 시설 정보를 처리하는 커스텀 훅입니다.
 */

import { useCallback } from "react";

/**
 * 상품 시설 관련 API 훅
 * 상품의 시설 목록을 생성하고 관리하는 기능을 제공합니다.
 */
const useProductFacilityApi = () => {
  /**
   * 공간 목록을 생성하는 함수
   * 상품의 타입(회의실, 휴게실, 데스크)에 따라 해당하는 시설 목록을 생성합니다.
   *
   * @param product - 상품 정보 객체
   * @returns 시설 목록 배열
   *
   * 반환되는 시설 정보:
   * - buildingName: 건물 이름
   * - isSelected: 선택 여부
   * - isSelectedId: 선택 ID
   * - 회의실/휴게실: 시설 기본 정보
   * - 데스크: 그룹명과 데스크 정보
   */
  const makeSpaceList = useCallback(async (product: any) => {
    const tableData: any = [];

    // 회의실 목록 생성
    if (product.isMeetingRoom) {
      product?.buildingList?.forEach((data: any) => {
        data.buildingCommonFacility?.meetingRoomList?.forEach((space: any) => {
          let returnDt = { ...space, buildingName: data.buildingName, isSelected: false, isSelectedId: "isSelected_" + space.id };
          tableData.push(returnDt);
        });
      });
    }

    // 휴게실 목록 생성
    if (product.isRefreshRoom) {
      product?.buildingList?.forEach((data: any) => {
        data.buildingCommonFacility?.refreshRoomList?.forEach((space: any) => {
          let returnDt = { ...space, buildingName: data.buildingName, isSelected: false, isSelectedId: "isSelected_" + space.id };
          tableData.push(returnDt);
        });
      });
    }

    // 데스크 목록 생성
    if (product.isDesk) {
      product?.buildingList?.forEach((data: any) => {
        data.buildingCommonFacility?.deskSpace?.deskGroupList?.forEach((deskGroup: any) =>
          deskGroup.deskList?.forEach((desk: any) => {
            let returnDt = {
              ...desk,
              groupName: deskGroup.groupName,
              buildingName: data.buildingName,
              isSelected: false,
              isSelectedId: "isSelected_" + desk.id,
            };
            tableData.push(returnDt);
          }),
        );
      });
    }

    return tableData;
  }, []);

  return { makeSpaceList };
};

export default useProductFacilityApi;
